import { render, staticRenderFns } from "./NewNote.vue?vue&type=template&id=0dda9214&"
import script from "./NewNote.vue?vue&type=script&lang=js&"
export * from "./NewNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports